<template>
  <sui-select :options="sessionOptions" v-bind="$attrs" v-on="$listeners" />
</template>
<script>
import { debounce } from 'lodash-es'

export default {
  name: 'SuiCompetitionSessionSelect',
  inject: {
    SuiForm: {
      default: null
    },
    SuiFormPage: {
      default: null
    }
  },
  props: {
    competitionId: {
      type: [Number, String],
      default: undefined
    },
    stageId: {
      type: [Number, String],
      default: undefined
    },
    matchId: {
      type: [Number, String],
      default: undefined
    }
  },
  data() {
    return {
      sessionOptions: []
    }
  },
  computed: {
    _model() {
      return (this.SuiForm && this.SuiForm.model) || {}
    },
    _competitionId() {
      if (this.competitionId !== undefined) {
        return this.competitionId
      }
      return this._model.competitionId
    },
    _stageId() {
      if (this.stageId !== undefined) {
        return this.stageId
      }
      return this._model.stageId
    },
    _matchId() {
      if (this.matchId !== undefined) {
        return this.matchId
      }
      return this._model.matchId
    }
  },
  watch: {
    _competitionId: {
      immediate: true,
      handler(val) {
        this.fetchOptions()
      }
    },
    _stageId: {
      immediate: true,
      handler(val) {
        this.fetchOptions()
      }
    },
    _matchId: {
      immediate: true,
      handler(val) {
        this.fetchOptions()
      }
    }
  },
  methods: {
    fetchOptions: debounce(async function () {
      await this.$nextTick()

      if (!this._competitionId || !this._stageId || !this._matchId) {
        this.sessionOptions = []
        return
      }

      let result = await this.$store.dispatch('MerchantSimbart/allActivityCompetitionStageMatchSession', {
        competitionId: this._competitionId,
        stageId: this._stageId,
        matchId: this._matchId
      })
      // 获取数据
      this.sessionOptions = result.map((item) => {
        return {
          value: item.id,
          label: `${!item.beginTime && !item.endTime ? `暂无场次` : `${item.beginTime} - ${item.endTime}`}`
        }
      })
    }, 500)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SimbartUI/components/business/competition/SuiCompetitionSessionSelect.vue